import React from 'react';

import classNames from 'classnames';

import { Typography } from '../Typography/Typography';
import styles from './BasketQuantity.module.css';

export type Props = {
  isV2?: boolean;
  quantity: number;
};

export const BasketQuantity = React.memo((props: Props) => {
  const {
    quantity,
    isV2,
  } = props;

  return (
    <Typography
      className={classNames(
        styles.basketQuantity,
        {
          [styles.basketQuantityV2]: isV2,
        },
      )}
    >
      {quantity}
    </Typography>
  );
});

BasketQuantity.displayName = 'BasketQuantity';
